(function FranchiseSnapshot($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Reports/franchiseSnapshot', function onload()
		{
			var $modal = $('.modal');

			expandCollapse('');

			$('.nav-tabs>li').click(function changeTab() {

				if ($(this).hasClass('active')) {
					return;
				}
				switch ($(this).data("type")) {
					case 'technology':
						Adzuki.Ajax.get('/Reports/snapshotTechnology/')
						.then(function populateTechnology(content) {
							$('#technology').html(content);
							expandCollapse('technology');
						});
					break;
					case 'marketing':
						Adzuki.Ajax.get('/Reports/snapshotMarketing/')
						.then(function populateMarketing(content) {
							$('#marketing').html(content);
							expandCollapse('marketing');
						});
					break;
					case 'financials':
						Adzuki.Ajax.get('/Reports/snapshotFinancials/')
						.then(function populateFinancials(content) {
							$('#financials').html(content);
							expandCollapse('financials');
							renderFinancialsChart('departure');
							renderFinancialsChart('purchase');
						});
					break;
					case 'training':
						Adzuki.Ajax.get('/Reports/snapshotTraining/')
						.then(function populateTraining(content) {
							$('#training').html(content);
							expandCollapse('training');
						});
					break;
					case 'analysis':
						Adzuki.Ajax.get('/Reports/snapshotAnalysis/')
						.then(function populateAnalysis(content) {
							var analysis_range;
							$('#analysis').html(content);
							analysis_range = $('#analysis-date-range').val();
							renderOverallCharts(analysis_range);
							expandCollapse('analysis');
						});
					break;
					case 'insurance':
						Adzuki.Ajax.get('/Reports/snapshotInsurance/')
						.then(function populateInsurance(content) {
							$('#insurance').html(content);
							renderAllianzChart();
							expandCollapse('insurance');
						});
					break;
					case 'tool-usage':
						Adzuki.Ajax.get('/Reports/snapshotToolUsage/')
						.then(function populateToolUsage(content) {
							$('#tool-usage').html(content);
							expandCollapse('tool-usage');
							// renderAllianzChart();
						});
					break;
					default:
					break;
				}
			});


			$('.franchise-snapshot').on('click', 'a.training-session', function showSessions()
			{
				var $self = $(this);
				event.preventDefault();

				Adzuki.Ajax.get('/Reports/getFranchiseTrainingSession/' + $self.data('event-id'))
				.then(function _showSessions(html) {
					$modal.find('.modal-title').text($self.data('event-name'));
					$modal.find('.modal-body').html(html);
					$modal.modal('show');
				});
			});
		});

		$('.franchise-snapshot').on('change', '#tech-date-range', function techDateRangeChanged() {
			var month = $(this).val();

			$('#date-range-loader').removeClass('invisible');
			Adzuki.Ajax.get('/Reports/snapshotTechnology/' + month)
			.then(function populateTechnology(content) {
				$('#technology').html(content);
				$('#date-range-loader').addClass('invisible');
			});
		});

		// When the time period select changes
		$('.franchise-snapshot').on('change', '#analysis-date-range', function analysisDateRangeChanged() {
			var analysis_range = $(this).val();
			$('#date-range-loader').removeClass('invisible');

			if ($('#analysis-type-overall').is(':checked')) {
				Adzuki.Ajax.get('/Reports/' + analysis_range + '/overall')
				.then(function populateAnalysis(content) {
					$('#analysis').html(content);
					renderOverallCharts(analysis_range);
					expandCollapse('analysis');
				});
			} else {
				Adzuki.Ajax.get('/Reports/snapshotAnalysis/' + analysis_range + '/by_agent')
				.then(function populateAnalysis(content) {
					$('#analysis').html(content);
					renderAgentCharts(analysis_range);
				});
			}
			expandCollapse('analysis');
		});

		// When the time period select on tool usage Tab changes
		$('.franchise-snapshot').on('change', '#tool-usage-date-range', function toolUsageDateRangeChanged() {
			var tool_usage_range = $(this).val();
			$('#date-range-loader').removeClass('invisible');

			Adzuki.Ajax.get('/Reports/snapshotToolUsage/' + tool_usage_range)
			.then(function populateAnalysis(content) {
				$('#tool-usage').html(content);
				expandCollapse('tool-usage');
			});
			expandCollapse('tool-usage');
		});

		// when the radios for "Overall" and "By Agent" change
		$('.franchise-snapshot').on('change', 'input[type=radio][name=period_type]', function analysisTypeChanged() {
			var analysis_range = $('#analysis-date-range').val();
			var analysis_type  = $(this).val();
			$('#date-range-loader').removeClass('invisible');

			Adzuki.Ajax.get('/Reports/snapshotAnalysis/' + analysis_range + '/' + analysis_type)
			.then(function populateAnalysis(content) {
				$('#analysis').html(content);

				if (analysis_type === 'overall') {
					renderOverallCharts(analysis_range);
				} else {
					renderAgentCharts(analysis_range);
				}
				expandCollapse('analysis');
			});
		});
	});


	function expandCollapse(type)
	{
		var expandCollapse;

		if (type === '') {
			expandCollapse = $('.expand_collapse');
		} else {
			expandCollapse = $("#" + type + " .expand_collapse");
		}

		expandCollapse.click(function expandCollapse() {
			var area = $(this).data('area');

			$('[data-toggle^="tooltip"]').tooltip('hide');

			if ($('#' + area).css('display') === 'none') {
				$(this).removeClass(Adzuki.FaIcon.getIconStyle('expand'));
				$(this).addClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
				$(this).attr('data-original-title', "Collapse section").tooltip('show');

				$('#' + area).removeClass('hidden');
				$('#' + area + '-button').addClass('hidden');

			} else {
				$(this).removeClass(Adzuki.FaIcon.getIconStyle('collapse', 'regular'));
				$(this).addClass(Adzuki.FaIcon.getIconStyle('expand'));
				$(this).attr('data-original-title', "Expand section").tooltip('show');

				$('#' + area).addClass('hidden');
				$('#' + area + '-button').removeClass('hidden');
			}

		});
		$('.see-more').click(function triggerSeeMore(e) {
			var area = $(this).data('area');

			e.preventDefault();

			expandCollapse.each(function clickTheRightOne() {
				if ($(this).data('area') === area) {
					$(this).trigger('click');
				}
			});
		});

	}
	/**
	 * Render all the "Overall" charts on the specified time period
	 * @param {string} time_period
	 * @return {void}
	 */
	function renderOverallCharts(time_period)
	{
		if ($('#analysis-type-overall').is(':checked')) {
			renderAnalysisChart('travelComponent', 'departures', time_period);
			renderAnalysisChart('travelComponent', 'purchases', time_period);
			renderAnalysisChart('cruiseLine', 'departures', time_period);
			renderAnalysisChart('cruiseLine', 'purchases', time_period);
			renderAnalysisChart('tourCompany', 'departures', time_period);
			renderAnalysisChart('tourCompany', 'purchases', time_period);
		}
	}

	/**
	 * Render all the "By Agent" charts on the specified time period
	 * @param {string} time_period
	 * @return {void}
	 */
	function renderAgentCharts(time_period)
	{
		$('.agent-chart').each(function onEachAgentChart(i, elem) {
			var agent_id       = $(elem).data('agent-id');
			var chart_type     = $(elem).data('chart-type');
			var breakdown_type = $(elem).data('breakdown-type');
			renderAgentAnalysisChart(agent_id, chart_type, breakdown_type, time_period);
		});
	}

	/**
	 * Render a sales analysis chart (departures or purchases) for franchise financials
	 * @param  {string}
	 * @return {void}
	 */
	function renderFinancialsChart(type)
	{
		var chart = new Adzuki.Chart('#sales-' + type + 's-chart', {
			width: '100%',
			title: '',
			vAxis: {
				title: 'Dollars'
			},
			hAxis: {
				title: 'Month of the Year'
			},
			colors: ['#3366CC', '#FF0000', '#ffa500', '#128806']
		});

		$(chart).on('ready', function chartReady()
		{
			Adzuki.Ajax.get('/Reports/financialsChart/' + type)
			.then(function getChartData(response)
			{
				chart.setData(response);
				chart.draw('column');
			});
		});
	}

	/**
	 * Render the allianz chart for the franchise overall analysis
	 * @return {void}
	 */
	function renderAllianzChart()
	{
		var chart = new Adzuki.Chart('#allianz-chart', {
			width: '100%',
			title: '',
			is3D : true
		});

		$(chart).on('ready', function chartReady()
		{
			Adzuki.Ajax.get('/Reports/allianzChart/')
			.then(function getChartData(response)
			{
				chart.setData(response);
				chart.draw('pie');
			});
		});
	}

	/**
	 * Render an analysis chart for the franchise overall by the specified time period
	 * This could be a breakdown of travel components, cruise lines or tour companies.
	 * @param  {string} chart_type
	 * @param  {string} breakdown_type
	 * @param  {string} time_period
	 * @return {void}
	 */
	function renderAnalysisChart(chart_type, breakdown_type, time_period)
	{
		var chart = new Adzuki.Chart('#' + chart_type + '-analysis-chart-' + breakdown_type, {
			width: '100%',
			title: '',
			is3D : true
		});

		$(chart).on('ready', function chartReady()
		{
			Adzuki.Ajax.get('/Reports/analysisChart/' + chart_type + '/' + breakdown_type + '/' + time_period)
			.then(function getChartData(response)
			{
				chart.setData(response);
				chart.draw('pie');
			});
		});
	}

	/**
	 * Render an analysis chart for an agent by the specified time period
	 * This could be a breakdown of cruise lines or tour companies
	 * @param  {int} agent_id
	 * @param  {string} chart_type
	 * @param  {string} breakdown_type
	 * @param  {string} time_period
	 * @return {void}
	 */
	function renderAgentAnalysisChart(agent_id, chart_type, breakdown_type, time_period)
	{
		var chart = new Adzuki.Chart('#agent-' + agent_id + '-' + chart_type + '-chart-' + breakdown_type, {
			width: '100%',
			title: '',
			is3D : true
		});

		$(chart).on('ready', function chartReady()
		{
			Adzuki.Ajax.get('/Reports/agentAnalysisChart/' + agent_id + '/' + chart_type + '/' + breakdown_type + '/' + time_period)
			.then(function getChartData(response)
			{
				chart.setData(response);
				chart.draw('pie');
			});
		});
	}

}(jQuery, window.Adzuki || {}));
